import React, { useState } from "react";
import { Mail, Loader2 } from "lucide-react";
import "../../css/leads/bulkemaildialog.css";

export default function BulkEmailDialog({
  open,
  onClose,
  selectedLeads,
  onSuccess,
}) {
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);

  if (!open) return null;

  const leadsWithEmail = selectedLeads.filter((l) => l.email);

  const handleSend = async () => {
    if (!subject.trim() || !message.trim()) {
      alert("Please fill subject and message");
      return;
    }

    setSending(true);

    try {
      let successCount = 0;

      for (const lead of leadsWithEmail) {
        const personalizedMessage = message.replace(
          /{name}/g,
          lead.full_name
        );

        // 🔁 Replace with your backend API
        await fakeSendEmail({
          to: lead.email,
          subject,
          body: personalizedMessage,
        });

        successCount++;
      }

      alert(`Successfully sent ${successCount} emails`);
      setSubject("");
      setMessage("");
      onSuccess();
      onClose();
    } catch (err) {
      alert("Error while sending emails");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="modal-backdrop">
      <div className="modal">
        {/* Header */}
        <div className="modal-header">
          <h2>
            <Mail size={18} /> Send Bulk Email
          </h2>
          <button className="close-btn" onClick={onClose}>
            ✕
          </button>
        </div>

        {/* Body */}
        <div className="modal-body">
          <div className="info-box">
            Sending to <b>{leadsWithEmail.length}</b> lead
            {leadsWithEmail.length !== 1 && "s"}
          </div>

          <label>Subject</label>
          <input
            type="text"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            disabled={sending}
          />

          <label>Message</label>
          <textarea
            rows={6}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Use {name} to personalize"
            disabled={sending}
          />

          <small>
            Tip: Use <code>{`{name}`}</code> to insert recipient name
          </small>

          <div className="preview">
            <strong>Preview:</strong>
            <p>
              {message.replace(
                /{name}/g,
                leadsWithEmail[0]?.full_name || "{name}"
              ) || "Your message will appear here"}
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="modal-footer">
          <button className="btn secondary" onClick={onClose} disabled={sending}>
            Cancel
          </button>

          <button
            className="btn primary"
            onClick={handleSend}
            disabled={sending}
          >
            {sending ? (
              <>
                <Loader2 className="spin" size={16} /> Sending...
              </>
            ) : (
              <>
                <Mail size={16} /> Send
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

/* Mock email sender */
function fakeSendEmail() {
  return new Promise((resolve) => setTimeout(resolve, 600));
}
